module.exports = __webpack_public_path__ + "img/tensor-flow.59143c9d.svg";